var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
import { Box, Chip, useMediaQuery } from "@mui/material";
import { GridActionsCellItem } from "@mui/x-data-grid-premium";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { DynamicCatalogBuilder } from "../../../builderPackage/components/dynamicCatalogBuilder/dynamicCatalogBuilder";
import { DesktopTabComponent } from "../../../components/molecules/desktopTabComponent";
import { ESystemName, LOCAL_STORAGE_KEYS } from "../../../constants";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";
import { secondaryTextGray } from "../../../theme/palette";
import { getLocalStorageItem } from "../../../utils/storageHelper";
import { dateFormate } from "../../../utils/utils";
import { DownloadIconSVG, PrintIconSVG, ShareOutlinedIconSVG } from "../../spareParts/purchaseRequistion/assets/customIcons";
import { WorkPurchaseOrderPagingAPI } from "../apiCall";
import { FilterWorkPurchaseOrder } from "../components/workPurchaseOrderFilterComponent";
import { WorkPurchaseOrderKeys } from "../entity";
import HeaderCatalogPageComponent from "../../../components/templates/headerCatalogPageUpdated";
import CardView from "../../proprietaryWarranty/pages/proprietaryCardView";
import { workPurchaseOrderUrl } from "../../../api/url";
import { resetState } from "../../../redux/crudSlice";
export var WorkPurchaseOrder = function () {
    var _crud$WorkPurchaseOrd;
    var navigate = useNavigate();
    var getStockTransferList = useAppSelector(function (state) { return state.crud; }).getStockTransferList;
    var isAllViewActive = useAppSelector(function (state) { return state.common; }).isAllViewActive;
    var crud = useAppSelector(function (state) { return state.crud; });
    var listVariants = ["My Work Purchase Order", "All Work Purchase Order"];
    var _a = useState("list"), activeView = _a[0], setActiveView = _a[1];
    var _b = useState(false), isFilterOpen = _b[0], setFilterOpen = _b[1];
    var filterValue = useAppSelector(function (state) { return state.crud; }).filterValue;
    var upXS = useMediaQuery(function (theme) { return theme.breakpoints.up("xs"); });
    var downSM = useMediaQuery(function (theme) { return theme.breakpoints.down("sm"); });
    var IS_MOBILE = upXS && downSM;
    var isDesktop = useMediaQuery(function (theme) { return theme.breakpoints.up('sm'); });
    var dispatch = useAppDispatch();
    var storedMenuFeatures = getLocalStorageItem(LOCAL_STORAGE_KEYS.MENU_FEATURE);
    var menuFeatures = storedMenuFeatures === null || storedMenuFeatures === void 0 ? void 0 : storedMenuFeatures.filter(function (data) { return !(data.Name == 'Cancel' || data.Name == 'Edit'); });
    var _c = useState(listVariants.length > 0 && isAllViewActive ? listVariants[0] : listVariants[1]), selectedListVariant = _c[0], setSelectedListVariant = _c[1];
    var selectedBranch = getLocalStorageItem("SELECTED_BRANCH");
    // let request: any = {
    //   OrganizationId: selectedBranch?.OrganizationId,
    //   IdentityId: crud?.profilePersonalDetails?.data?.IdentityId,
    //   ParentOrganizationId: selectedBranch?.ParentOrganizationId,
    //   Type: "WorkPurchaseOrder",
    //   DocumentDate: {},
    //   take: 10,
    //   skip: 0,
    // };
    var getPagingRequest = function () {
        var _crud$profilePersonal;
        var request = {
            take: 2,
            skip: 0,
            OrganizationId: selectedBranch === null || selectedBranch === void 0 ? void 0 : selectedBranch.OrganizationId,
            ParentOrganizationId: selectedBranch === null || selectedBranch === void 0 ? void 0 : selectedBranch.ParentOrganizationId,
            Type: "WorkPurchaseOrder",
            DocumentDate: {},
            IdentityId: selectedListVariant === "My Work Purchase Order" ? crud === null || crud === void 0 || (_crud$profilePersonal = crud.profilePersonalDetails) === null || _crud$profilePersonal === void 0 || (_crud$profilePersonal = _crud$profilePersonal.data) === null || _crud$profilePersonal === void 0 ? void 0 : _crud$profilePersonal.IdentityId : undefined
        };
        return request;
    };
    useEffect(function () {
        // if (selectedListVariant === "My Work Purchase Order") {
        //   request.IdentityId = crud?.profilePersonalDetails?.data?.IdentityId;
        // }
        WorkPurchaseOrderPagingAPI({
            key: WorkPurchaseOrderKeys.Paging,
            request: getPagingRequest(),
            url: workPurchaseOrderUrl
        });
    }, [selectedListVariant]);
    var data = (_crud$WorkPurchaseOrd = crud[WorkPurchaseOrderKeys === null || WorkPurchaseOrderKeys === void 0 ? void 0 : WorkPurchaseOrderKeys.Paging]) === null || _crud$WorkPurchaseOrd === void 0 ? void 0 : _crud$WorkPurchaseOrd.data;
    console.log('Paging Key Data ---', data);
    var handleSelectMenu = function (listVariant) {
        dispatch(resetState(['workPurchaseOrderPagingData']));
        setSelectedListVariant(listVariant);
    };
    var onToggleViewChange = function (value) {
        setActiveView(value);
    };
    var onClickCreateModule = function () {
        navigate("/createWorkPurchaseOrder?mode=add");
    };
    var handleClickFilterIcon = function () {
        setFilterOpen(function (prev) { return !prev; });
    };
    var handleRowClick = function (id) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            WorkPurchaseOrderPagingAPI({
                request: {
                    id: id
                }
            });
            navigate("./createWorkPurchaseOrder/".concat(id, "?mode=edit"));
            return [2 /*return*/];
        });
    }); };
    var getRequest = function () {
        var filter = filterValue === null || filterValue === void 0 ? void 0 : filterValue.data;
        var request = {
            // Branches:['5e75d742-c9a5-429e-b825-a80e21208d36'],
            FromDate: filter !== null && filter !== void 0 && filter.FromDate ? filter === null || filter === void 0 ? void 0 : filter.FromDate : "",
            ToDate: filter !== null && filter !== void 0 && filter.ToDate ? filter === null || filter === void 0 ? void 0 : filter.ToDate : filter !== null && filter !== void 0 && filter.FromDate ? filter === null || filter === void 0 ? void 0 : filter.FromDate : ""
        };
        if (filter !== null && filter !== void 0 && filter.Type) {
            var _filter$Type;
            request = _objectSpread(_objectSpread({}, request), {}, {
                Type: filter === null || filter === void 0 || (_filter$Type = filter.Type) === null || _filter$Type === void 0 ? void 0 : _filter$Type.map(function (item) { return item.PurchaseOrderTypeId; })
            });
        }
        if (filter !== null && filter !== void 0 && filter.Priority) {
            var _filter$Priority;
            request = _objectSpread(_objectSpread({}, request), {}, {
                Priority: filter === null || filter === void 0 || (_filter$Priority = filter.Priority) === null || _filter$Priority === void 0 ? void 0 : _filter$Priority.map(function (item) { return item.Name; })
            });
        }
        return request;
    };
    var customActionColumns = [{
            field: "DocumentNumber",
            headerName: "Document no.",
            align: "center",
            minWidth: 150
        }, {
            field: "DocumentDate",
            headerName: "Document date",
            valueFormatter: function (val, row) { return row !== null && row !== void 0 && row.ExpectedTransferDate ? "".concat(dateFormate(dayjs(row === null || row === void 0 ? void 0 : row.ExpectedTransferDate))) : '-'; },
            minWidth: 150
        }, {
            field: "SupplierName",
            headerName: "Supplier",
            minWidth: 110
        }, {
            field: "JobCardNo",
            headerName: "Job card no.",
            minWidth: 220
        }, {
            field: "VIN",
            headerName: "VIN reference",
            minWidth: 180
        }, {
            field: "TotalAmount",
            headerName: "Total amount",
            minWidth: 120
        }, {
            field: "ServiceAdvisor",
            headerName: "Service Advisior",
            minWidth: 110
        }, {
            field: 'Status',
            headerName: 'Status',
            minWidth: 150,
            renderCell: function (params) {
                var _params$row, _params$row$Status, _params$row2;
                return (params === null || params === void 0 || (_params$row = params.row) === null || _params$row === void 0 ? void 0 : _params$row.Status) && /*#__PURE__*/ React.createElement(Chip, {
                    label: (_params$row$Status = params === null || params === void 0 || (_params$row2 = params.row) === null || _params$row2 === void 0 ? void 0 : _params$row2.Status) !== null && _params$row$Status !== void 0 ? _params$row$Status : '-',
                    size: "small",
                    variant: "outlined",
                    sx: {
                        borderRadius: 2,
                        px: 1,
                        fontWeight: 500,
                        fontSize: 12,
                        color: 'black'
                    },
                    icon: /*#__PURE__*/ React.createElement(Box, {
                        height: 8,
                        width: 8,
                        borderRadius: 10,
                        bgcolor: "gray"
                    })
                });
            }
        }, {
            type: "actions",
            field: "actions",
            headerName: "",
            flex: 1,
            getActions: function (params) {
                var actions = [/*#__PURE__*/ React.createElement(GridActionsCellItem, {
                        label: "Print",
                        icon: /*#__PURE__*/ React.createElement(PrintIconSVG, {
                            sx: {
                                color: secondaryTextGray,
                                width: 16,
                                height: 16
                            }
                        }),
                        showInMenu: true
                    }), /*#__PURE__*/ React.createElement(GridActionsCellItem, {
                        label: "DownloadPDF",
                        icon: /*#__PURE__*/ React.createElement(DownloadIconSVG, {
                            sx: {
                                color: secondaryTextGray,
                                width: 16,
                                height: 16
                            }
                        }),
                        showInMenu: true
                    })];
                if (params.row.StatusName === "Draft") {
                    actions.push(/*#__PURE__*/ React.createElement(GridActionsCellItem, {
                        label: "SendForApproval",
                        icon: /*#__PURE__*/ React.createElement(ShareOutlinedIconSVG, {
                            sx: {
                                color: secondaryTextGray,
                                width: 16,
                                height: 16
                            }
                        }),
                        showInMenu: true,
                        onClick: function () {
                            // handleSendForApprovalClick(params);
                        }
                    }));
                }
                return actions;
            }
        }];
    return /*#__PURE__*/ React.createElement(React.Fragment, null, activeView === 'list' && isDesktop && /*#__PURE__*/ React.createElement(DesktopTabComponent, {
        items: listVariants
    }), /*#__PURE__*/ React.createElement(Box, null, /*#__PURE__*/ React.createElement(HeaderCatalogPageComponent, {
        handleClickFilterIcon: handleClickFilterIcon,
        selectedMenuItem: selectedListVariant,
        menus: listVariants.length > 0 ? listVariants : undefined,
        onSelectMenu: handleSelectMenu,
        activeView: activeView,
        onToggleView: onToggleViewChange,
        totalCount: getStockTransferList === null || getStockTransferList === void 0 ? void 0 : getStockTransferList.TotalCount,
        onClickCreateModule: onClickCreateModule,
        createButtonText: "New",
        isCreateButton: true,
        moduleName: ESystemName.WorkPurchaseOrder,
        title: "Work Purchase Order"
    })), activeView === 'list' && isDesktop && /*#__PURE__*/ React.createElement(Box, {
        p: 2
    }, /*#__PURE__*/ React.createElement(DynamicCatalogBuilder, {
        getPagingData: WorkPurchaseOrderPagingAPI,
        pagingAPIKey: WorkPurchaseOrderKeys.Paging,
        pagingAPIRequest: getPagingRequest(),
        columns: customActionColumns,
        dataGridProps: {
            paginationMode: "client"
        }
    })), (activeView === 'grid' || IS_MOBILE) && /*#__PURE__*/ React.createElement(Box, {
        py: 2
    }, /*#__PURE__*/ React.createElement(CardView, {
        pagingApiCall: WorkPurchaseOrderPagingAPI,
        pagingKey: WorkPurchaseOrderKeys.Paging,
        pagingRequest: getPagingRequest(),
        pageSize: 20,
        cardMapper: function (data) {
            // console.log('Paging data ----', data)
            return {
                id: "card-".concat(data.id),
                docNo: data.DocumentNumber,
                title: dateFormate(data === null || data === void 0 ? void 0 : data.DocumentDate),
                statusName: data === null || data === void 0 ? void 0 : data.Status,
                details: [{
                        label: "Supplier",
                        value: data === null || data === void 0 ? void 0 : data.SupplierName
                    }, {
                        label: "VIN reference:",
                        value: data === null || data === void 0 ? void 0 : data.VIN
                    }, {
                        label: "Job card reference no:",
                        value: data === null || data === void 0 ? void 0 : data.JobCardNo
                    }, {
                        label: "Service Advisor:",
                        value: data === null || data === void 0 ? void 0 : data.ServiceAdvisor
                    }]
            };
        },
        callIconVisibleFor: 'Supplier'
        // actionsMenu={menuFeatures}
        // menuIcons={getIcon}
        // onCardClick={handleRowClick}
    })), /*#__PURE__*/ React.createElement(FilterWorkPurchaseOrder, {
        isFilterOpen: isFilterOpen,
        setFilterOpen: function (prev) { return setFilterOpen(prev); }
    }));
};
